export const environment = {
  production: true,
  database: 'verify-enterprise',
  localeId: 'nl',
  functionRegion: 'europe-west1',
  useEmulators: false,
  sentryDsn:
    'https://249bc361ddd8d56348fe0daede6511e2@o4510992598695936.ingest.de.sentry.io/4510997698248784',
  sentryEnvironment: 'production-eu',
  reCaptchaSiteKey: '6LdK4zUtAAAAAN4ZRBtCCqny1MMsyfgBDxZRFXa4',
  firebaseConfig: {
    apiKey: 'AIzaSyB8AnxCjytUqTj8rz83Hen2sKVfHeSH2pg',
    authDomain: `${window.location.host.split('.')[0]}.verifyconsent.ai`,
    projectId: 'fir-apps-prod-eu',
    storageBucket: 'fir-apps-prod-eu.appspot.com',
    messagingSenderId: '748147608117',
    appId: '1:748147608117:web:7f92d08570d51b66cc7f7c',
    measurementId: 'G-0353PZVGP0',
  },
};
